export default {
  // START:: SET APP THEME
  setAppTheme(state, payload) {
    state.Tard_admin_dashboard_theme = payload;
  },
  // END:: SET APP THEME
};
